import './style.scss'

const prefixCls = 'sl-tree';

const Node = {
  props: ['id','enableTitleExpand','autoExpandParent'],
  computed: {
    classes() {
      return {
        [`${prefixCls}-node-active`]: this.active,
        [`${prefixCls}-node-open`]: this.opened
      };
    },
  },
  data() {
    return {
      active: false,
      opened: false,
    };
  },
  created(){
    this.$watch('autoExpandParent',function(nv){
      this.opened = nv
    },{immediate:true})
  },
  methods: {
    handleClickExpand() {
      if (this.disabled) return;
      const opened = this.opened;
      this.opened = !opened;
      //this.$emit('click' , this.id)
    },
    handleClick(){
      if (this.disabled) return;
      if( this.enableTitleExpand === true ){
        const opened = this.opened;
        this.opened = !opened;
      }
      this.$emit('click' , this.id)
    }
  },

  render() {
    const { classes, handleMouseenter, handleMouseleave, handleClick, $scopedSlots, opened , handleClickExpand} = this

    const defaultNode = $scopedSlots.default ? <transition><ul class={[prefixCls]} v-show={opened}>{$scopedSlots.default()}</ul></transition> : null

    const actionsNode = $scopedSlots.actions ? <span class={[prefixCls + '-node-actions']}>{ $scopedSlots.actions() }</span> : null

    const expandNode = $scopedSlots.default ? <span on-click={handleClickExpand} class={[prefixCls + '-node-expand']}><Icon type="ios-arrow-down"></Icon></span> : null

    const titleNode = $scopedSlots.title ? <span on-click={handleClick} class={[prefixCls + '-node-title']}>{$scopedSlots.title()}</span> : null

    return (
      <li class={classes}>
        <div class={[prefixCls + '-node-wrapper']}>
          {expandNode}
          {titleNode}
          {actionsNode}
        </div>
        {defaultNode}
      </li>
    )
  }
}

const flatten = (d , key = 'id', pid = null) => d.reduce((t,c) => {
  if( pid !== null ){
    c._parent_id = pid
  }
  return t.concat({...c} , c.children ? flatten(c.children || [] , key , c[key]) : [])
} , [])


const childrenId = (d , key = 'id') => d.reduce((t,c) => t.concat(c[key] , c.children ? childrenId(c.children || [] , key) : []) , [])

const equalChecked = (a , b) => {
  return (a && b) ? ([...a].sort().toString() === [...b].sort().toString()) : false
}

export default {
  name: 'Tree',
  props: {
    data:Array,
    showLine:{
      type:Boolean,
      default:true
    },
    checkable:{
      type:Boolean,
      default:false
    },
    parentCheck:{
      type:Boolean,
      default:false
    },
    checkedKeys:{
      type:Array,
      default(){
        return []
      }
    },
    autoExpandParent:{
      type:Boolean,
      default:false
    },
    size:{
      default:'default'
    },
    keyField:{
      type:String,
      default:'id'
    },
    enableTitleExpand:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return {
      flatData:[],
      currentChecked:[],
      currentSelect:null
    }
  },
  created(){
    this.$watch('data' , function(nv){
      if(nv){
        //扁平化 设置 parentId
        this.flatData = flatten(nv , this.keyField)
      }
    },{immediate:true})

    this.$watch('checkedKeys' , function(nv , ov){
      if(nv && equalChecked(nv , this.currentChecked) == false){
        this.currentChecked = this.processCheck( nv.map(i => i) )
      }
    },{immediate:true})
  },
  methods: {
    processCheck(ids){
      let { flatData , currentChecked , keyField } = this
      let set = new Set(ids)

      for(let id of ids){
        let target = flatData.find( i => i[keyField] == id )
        
        let parent = target
        //祖先
        while(parent && parent._parent_id){
          let hit = flatData.find(i => i[keyField] == parent._parent_id)
          if( hit ){
            if( hit.children.every( i => set.has(i[keyField]) ) ){
              set.add( hit[keyField] )
            }
            parent = hit
          }else{
            parent = null
          }

        }

        //后代
        if( target.children){
          for(let i of childrenId(target.children,keyField)){
            set.add(i)
          }
        }

      }

      return Array.from(set)
    },

    handleChecked(item){
      let { currentChecked , flatData , keyField} = this
      let idx = currentChecked.findIndex( i => i == item[keyField] )
      let createKey = [] , removeKey = []

      let set = new Set(currentChecked)
      let checked = set.has(item[keyField]) == false
      
      // 处理本级
      if(checked){
        set.add(item[keyField])
      }else{
        set.delete(item[keyField])
      }

      //处理父级
      let target = item
      while(target && target._parent_id){
        let hit = flatData.find(i => i[keyField] == target._parent_id)

        if( hit ){
          if( hit.children.every( i => set.has(i[keyField]) ) ){
            set.add( hit[keyField] )
          }else{
            set.delete( hit[keyField] )
          }
          target = hit
        }else{
          target = null
        }
      }

      //子级
      if( item.children){
        for(let i of childrenId(item.children,keyField)){
          if(checked){
            set.add(i)
          }else{
            set.delete(i)
          }
        }
      }

      this.currentChecked = Array.from(set)
      
      this.$emit('check' , this.currentChecked)
    },
    handleClick(id){
      const { keyField } = this
      const hit = this.flatData.find(i => i[keyField] == id)
      this.currentSelect = id
      this.$emit('click' , id , hit)
      if( hit && !hit.children){
        if( this.checkable && (this.parentCheck || (!this.parentCheck && !hit.children))){
          this.handleChecked(hit)
        }
      }
    },
    renderItem(item) {
      const { $scopedSlots } = this
      return $scopedSlots.title ? $scopedSlots.title(item) : item.title ? item.title : item.name
    },
    renderActions(item){
      const { $scopedSlots , checkable , parentCheck } = this
      if( checkable ){
        return parentCheck || (!parentCheck && !item.children) ?  this.renderCheck(item) : null
      }
      return $scopedSlots.actions ? $scopedSlots.actions(item) : null
    },
    renderCheck(item){
      const { currentChecked , keyField } = this
      return <span on-click={() => this.handleChecked(item)} class={{'sl-tree-checkbox':1 , 'sl-tree-checkbox-checked':currentChecked.includes(item[keyField])}}><span class="sl-tree-checkbox-inner"></span></span>
    },
    renderGroup(item) {
      const { renderItem , renderActions , renderGroup , keyField , currentSelect} = this

      const children = (item.children && item.children.length) ? item.children.map(renderGroup) : null
      
      return (
        <Node class={{[`${prefixCls}-node-select`]:item[keyField] == currentSelect}} id={item[keyField]} on-click={this.handleClick} autoExpandParent={this.autoExpandParent} enable-title-expand={this.enableTitleExpand}>
          <template slot="title">
            { renderItem(item) }
          </template>
          <template slot="actions">
            { renderActions(item) }
          </template>
          {children}
        </Node>
      )
    }
  },
  render() {
    const { data, renderGroup , size} = this
    return (
      <ul class={[prefixCls , ['sm','md','lg'].includes(size) ? `${prefixCls}-${size}` : null]}>
        { data.map( renderGroup ) }
      </ul>
    )
  }
}